import { render, staticRenderFns } from "./ProductCharacteristicSideBar.vue?vue&type=template&id=48ba4d85&scoped=true&"
import script from "./ProductCharacteristicSideBar.vue?vue&type=script&lang=js&"
export * from "./ProductCharacteristicSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ProductCharacteristicSideBar.vue?vue&type=style&index=0&id=48ba4d85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba4d85",
  null
  
)

export default component.exports